import { FC, useMemo, useCallback } from 'react';
import intl from 'react-intl-universal';
import { FormItem, Dropdown } from '@getsynapse/design-system';
import { ProjectStatus } from 'utils/types/projectsList';
import {
  ACTIVE_PROJECTS_STATUSES,
  PROJECT_STATUS,
} from 'utils/constants/projectsList';
import { Option } from 'utils/customTypes';

interface ProjectStatusFilterProps {
  onSelect: (selected: ProjectStatus[]) => void;
  selected?: ProjectStatus[];
  isConsolidatedView?: boolean;
}

const ProjectStatusFilter: FC<ProjectStatusFilterProps> = ({
  selected,
  onSelect,
  isConsolidatedView = false,
}) => {
  const statusOptions = useMemo(() => {
    if (isConsolidatedView) {
      return Object.values(PROJECT_STATUS).map((key) => ({
        value: key,
        label: intl.get(`PROJECT_DETAIL.STATUS_OPTIONS.${key.toUpperCase()}`),
      }));
    }

    return ACTIVE_PROJECTS_STATUSES.map((key) => ({
      value: key,
      label: intl.get(`PROJECT_DETAIL.STATUS_OPTIONS.${key.toUpperCase()}`),
    }));
  }, [isConsolidatedView]);

  const selectedOptions = useMemo(() => {
    return statusOptions.filter((option) =>
      selected?.includes(option.value as ProjectStatus)
    );
  }, [statusOptions, selected]);

  const handleOnChange = useCallback(
    (selectedOptions: Option[]) => {
      const selectedValues = selectedOptions.map((option) => option.value);
      onSelect(selectedValues as ProjectStatus[]);
    },
    [onSelect]
  );

  return (
    <FormItem label={intl.get('PROJECTS_LIST_PAGE.TABLE.HEAD.STATUS')}>
      <Dropdown
        options={statusOptions}
        values={selectedOptions}
        onChange={handleOnChange}
        multiple
        placeholder={intl.get('FILTER_GENERAL.PLACEHOLDER')}
        triggerProps={{
          'aria-label': 'project-status-filter',
        }}
      />
    </FormItem>
  );
};

export default ProjectStatusFilter;
